const SvgChip = props => (
  <svg height="1em" viewBox="0 0 14 16" width="1em" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(-2 -1)">
      <path d="M0 0h18v18H0z" />
      <path
        d="M16 4.5a.5.5 0 0 1-.5.5H13V4h2.5a.5.5 0 0 1 .5.5zM2 4.5a.5.5 0 0 1 .5-.5H5v1H2.5a.5.5 0 0 1-.5-.5zM16 7.5a.5.5 0 0 1-.5.5H13V7h2.5a.5.5 0 0 1 .5.5zM2 7.5a.5.5 0 0 1 .5-.5H5v1H2.5a.5.5 0 0 1-.5-.5zM16 10.5a.5.5 0 0 1-.5.5H13v-1h2.5a.5.5 0 0 1 .5.5zM2 10.5a.5.5 0 0 1 .5-.5H5v1H2.5a.5.5 0 0 1-.5-.5zM16 13.5a.5.5 0 0 1-.5.5H13v-1h2.5a.5.5 0 0 1 .5.5zM2 13.5a.5.5 0 0 1 .5-.5H5v1H2.5a.5.5 0 0 1-.5-.5z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <rect
        height={15}
        rx={1}
        stroke="currentColor"
        width={9}
        x={4.5}
        y={1.5}
      />
    </g>
  </svg>
)

export default SvgChip
